module.exports = __webpack_public_path__ + "static/media/AMOUNT KWH.d3aa74fe.png";